import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsSaveDraftButtonAvailable, selectIsSaveDraftButtonDisabled } from '../../selectors/checkoutInfo';
import { selectIsSaveDraftPending } from '../../selectors/draft';
import { SaveDraftButton } from './SaveDraftButton';
import { saveOfferDraft } from '../../actions/webview';
import { saveDraftStart } from '../../actions/draft';
import { AppContext } from '../../../AppModulesWrapper';

export const SaveDraftButtonContainer = () => {
  const { webview } = React.useContext(AppContext);

  const isSaveDraftButtonAvailable = useSelector(selectIsSaveDraftButtonAvailable);
  const isSaveDraftButtonDisabled = useSelector(selectIsSaveDraftButtonDisabled);
  const isPending = useSelector(selectIsSaveDraftPending);

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    dispatch(saveDraftStart());

    webview.sendAction(saveOfferDraft());
  }, [webview, dispatch]);

  if (!isSaveDraftButtonAvailable) {
    return null;
  }

  return <SaveDraftButton isDisabled={isSaveDraftButtonDisabled} isPending={isPending} onClick={handleButtonClick} />;
};
